import { motion } from "framer-motion";
import { Fuel, Wrench, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";

const ChallengeSection = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation('home');

  const challenges = [
    { icon: Fuel, title: t('challenge.fuelTitle'), bold: t('challenge.fuelBold'), rest: t('challenge.fuelRest') },
    { icon: Wrench, title: t('challenge.uptimeTitle'), bold: t('challenge.uptimeBold'), rest: t('challenge.uptimeRest') },
    { icon: FileText, title: t('challenge.reportsTitle'), bold: t('challenge.reportsBold'), rest: t('challenge.reportsRest') },
  ];

  return (
    <section className="py-20 md:py-28 section-fade">
      <div className="container mx-auto px-6">
        <motion.div initial={isMobile ? false : { opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: isMobile ? 0 : 0.7 }} className="text-center mb-16 max-w-3xl mx-auto">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">{t('challenge.label')}</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground leading-tight">{t('challenge.heading')}</h2>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-3 sm:divide-x divide-border">
          {challenges.map((item, i) => (
            <motion.div key={i} initial={isMobile ? false : { opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: isMobile ? 0 : 0.5, delay: isMobile ? 0 : i * 0.08 }} className="px-8 py-6 text-left">
              <item.icon size={24} className="text-muted-foreground/50 mb-4" />
              <h3 className="text-base font-semibold text-foreground mb-2">{item.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{item.bold} {item.rest}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChallengeSection;
